import { render, staticRenderFns } from "./StepAccount.vue?vue&type=template&id=3b3b23d1"
import script from "./StepAccount.vue?vue&type=script&lang=js"
export * from "./StepAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports